import { api } from "./api";
import {
  PaymentRequest,
  TransactionDetails,
  PaymentRequestResponse,
  PublicPaymentRequest,
} from "../../types/PaymentRequestTypes";
import { transformObjectFields } from "../../utils/objects";

const transformPaymentRequest = (paymentRequest: PaymentRequest) =>
  transformObjectFields<PaymentRequest>(paymentRequest, {
    amount_atomic: Number,
    amount: Number,
    transaction_details: transformTransactionDetails,
  });

const transformTransactionDetails = (transactionDetails: TransactionDetails) =>
  transformObjectFields<TransactionDetails>(transactionDetails, {
    amount: Number,
    commission_percent: Number,
    commission_amount: Number,
    outgoing_amount: Number,
    tds: Number,
    tds_amount: Number,
    outgoing_amount_after_tds: Number,
  });

export const paymentRequestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentRequests: builder.query<PaymentRequestResponse, void>({
      query: () => ({
        url: "/payment_requests/",
      }),
      providesTags: ["PaymentRequests"],
      transformResponse: (response: PaymentRequestResponse) => ({
        ...response,
        results: response.results.map(transformPaymentRequest),
      }),
    }),
    getPaymentRequest: builder.query<PaymentRequest, string>({
      query: (payload) => ({
        url: `/payment_requests/${payload}/`,
      }),
      providesTags: ["PaymentRequests"],
      transformResponse: transformPaymentRequest,
    }),
    createPublicPaymentRequest: builder.mutation<
      PublicPaymentRequest,
      Partial<PublicPaymentRequest>
    >({
      query: (payload) => ({
        url: "/public/payment_requests/",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetPaymentRequestsQuery,
  useGetPaymentRequestQuery,
  useCreatePublicPaymentRequestMutation,
} = paymentRequestApi;
